import styles from "./Footer.module.css";
import { useIntl } from "react-intl";
import { Link, useNavigate } from "react-router-dom";
import Youtube from "./img/Vector (3).svg";
import linkedin from "./img/ri_linkedin-fill.svg";
import mail from "./img/ic_outline-email.svg";
const Footer = () => {
  const intl = useIntl();

  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.grid}>
          <div className={styles.brand}>
            <div className={styles.logo}>viewStruct</div>
            <p className={styles.brandDescription}>
              {intl.formatMessage({ id: "footerId1" })}
            </p>
            <div className={styles.socialButtons}>
              <button className={styles.socialBtn}>
                <img src={mail} alt="Mail" />
              </button>
              <Link
                to="https://www.linkedin.com/company/viewstruct"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button className={styles.socialBtn}>
                  <img src={linkedin} alt="LinkedIn" />
                </button>
              </Link>
              <Link
                to="https://www.youtube.com/results?search_query=viewstruct"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button className={styles.socialBtn}>
                  <img src={Youtube} alt="YouTube" />
                </button>
              </Link>
            </div>
          </div>

          <div className={styles.column}>
            <h4> {intl.formatMessage({ id: "footerId2" })}</h4>
            <ul className={styles.linkList}>
              <li>
                <a href="#">{intl.formatMessage({ id: "footerId3" })}</a>
              </li>
              <li>
                <a href="#">{intl.formatMessage({ id: "footerId4" })}</a>
              </li>
              <li>
                <a href="#">{intl.formatMessage({ id: "footerId5" })}</a>
              </li>
              <li>
                <a href="#">{intl.formatMessage({ id: "footerId6" })}</a>
              </li>
            </ul>
          </div>

          <div className={styles.column}>
            <h4>{intl.formatMessage({ id: "footerId7" })}</h4>
            <ul className={styles.linkList}>
              <li>
                <a href="#">{intl.formatMessage({ id: "footerId8" })}</a>
              </li>
              <li>
                <Link to="/HelpCenter">
                  {intl.formatMessage({ id: "footerId9" })}
                </Link>
              </li>
              <li>
                <Link to="/Contact">
                  {intl.formatMessage({ id: "footerId10" })}
                </Link>
              </li>

              <li>
                <Link to="/Issues">
                  {intl.formatMessage({ id: "footerId11" })}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className={styles.bottomSection}>
          <p className={styles.copyright}>
            {intl.formatMessage({ id: "footerId12" })}
          </p>
          <div className={styles.bottomLinks}>
            <Link to="/privacy-policy">
              {intl.formatMessage({ id: "footerId13" })}
            </Link>
            <Link to="/terms-of-service">
              {intl.formatMessage({ id: "footerId14" })}
            </Link>
            <Link to="/Dashboard">
              {intl.formatMessage({ id: "footerId15" })}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
